import React, { useState } from "react";
import { Form, Input, Spin } from "antd";
import google from "../../common/assets/images/google.svg";
import facebook from "../../common/assets/images/facebookShadow.svg";
import twitter from "../../common/assets/images/twitter.svg";
import banner from "../../common/assets/images/loginBanner.png";
import { signUp } from "../../utils/api";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notMatchedError, setNotMatchedError] = useState("");

  const onFinish = (values) => {
    setLoading(true);
    signUp(values)
      .then((res) => {
        if (res?.data) {
          localStorage.setItem("token", res?.data?.data?.accessToken);
          navigate("/form_page");
        }
        if (res?.response?.data?.statusCode == 400) {
          setNotMatchedError(res?.response?.data?.message);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 48,
            color: "black",
          }}
          spin
        />
      }
    >
      <div className="authGradient py-[50px] md:py-[100px]">
        <div className="container bg-white flex flex-col md:flex-row">
          {/* Form Section */}
          <div className="loginForm w-full md:w-1/2 p-10 md:p-20">
            <p className="font-medium text-xl pb-6 md:pb-10">Sign Up for an Account</p>
            <Form
              name="basic"
              style={{ maxWidth: 600 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              className="colorPlaceholder"
            >
              <Form.Item name="name" className="pb-5" rules={[{ required: true, message: "Please input your name!" }]}>
                <Input placeholder="Name" className="p-4 bg-[#D9D9D947] border-none w-full" />
              </Form.Item>
              
              <Form.Item name="email" className="pb-5" rules={[{ required: true, message: "Please input your email" }]}>
                <Input placeholder="Email" className="p-4 bg-[#D9D9D947] border-none w-full" />
              </Form.Item>
              
              <Form.Item name="password" className="pb-5" rules={[{ required: true, message: "Please input your password!" }]}>
                <Input.Password placeholder="Password" className="p-4 bg-[#D9D9D947] border-none w-full" />
              </Form.Item>
              
              <Form.Item name="phone" className="pb-5" rules={[{ required: true, message: "Please input your phone!" }]}>
                <Input placeholder="Phone" type="number" className="p-4 bg-[#D9D9D947] border-none w-full" />
              </Form.Item>

              {notMatchedError && <p className="text-red-500">{notMatchedError}</p>}
              
              <Form.Item>
                <button htmlType="submit" className="darkBlue text-white w-full py-4 md:py-5 rounded-xl">
                  Sign Up
                </button>
              </Form.Item>
            </Form>

            {/* Social Login Section */}
            <div className="text-center">
              <hr className="w-[70%] mx-auto bg-[#615858c7] border-[1px]" />
              <p className="pt-6 md:pt-10 font-medium text-base pb-4 md:pb-6">Or sign up with</p>
              <div className="flex justify-center gap-3">
                <img src={google} className="cursor-pointer w-10 md:w-12" alt="Google Login" />
                <img src={facebook} className="cursor-pointer w-10 md:w-12" alt="Facebook Login" />
                <img src={twitter} className="cursor-pointer w-10 md:w-12" alt="Twitter Login" />
              </div>
            </div>

            <div className="text-center font-medium text-base pt-6 md:pt-[103px] cursor-pointer">
              Already a member? Log In
            </div>
          </div>

          {/* Image Section */}
          <div className="loginImage w-full md:w-1/2">
            <img
              src={banner}
              className="w-full h-auto md:h-full min-h-[300px] md:min-h-[818px] object-cover object-right"
              alt="Login Banner"
            />
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Register;
